import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useModal, usePoll } from '../../../../hooks'
import { EModalName } from '../../../../types/enums'
import type { UnhandledMessageType } from '../../../organisms/MultiTable/types'

export const useHandleIncomingMessages = (props: {
  userId: string
  incomingMessage: UnhandledMessageType | null
  onHandleQueueMessage: () => void
  onCloseTable: () => void
}) => {
  const { openInfoModal } = useModal()
  const { t } = useTranslation()
  const { handlePollState } = usePoll({
    userId: props.userId,
  })

  const handleIncomingMessage = async (data: UnhandledMessageType) => {
    switch (data.type) {
      case 'notification': {
        if ('text' in data.data) {
          const { closeModal } = openInfoModal(
            {
              text: data.data.text,
            },
            {
              title: 'Notification',
            },
          )
          await closeModal
        }
        break
      }
      case 'action': {
        if (data.data.action === 'KICK') {
          const { closeModal } = openInfoModal(
            {
              text: t('modal.info.youKicked.text'),
            },
            {
              title: t('modal.info.youKicked.title'),
              name: EModalName.TABLE_YOU_WAS_KICKED,
            },
          )
          await closeModal
          props.onCloseTable()
          return
        }
        if (data.data.action === 'DISCONNECT') {
          if (data.data.reason === 'TABLE_DELETED') {
            const { closeModal } = openInfoModal(
              {
                text: t('modal.info.tableDeleted.text'),
              },
              {
                title: t('modal.info.tableDeleted.title'),
                name: EModalName.TABLE_WAS_DELETED,
              },
            )
            await closeModal
            props.onCloseTable()
            return
          } else if (data.data.reason === 'TABLE_NOT_FOUND') {
            const { closeModal } = openInfoModal(
              {
                text: t('modal.info.privateTableNotFound.text'),
              },
              {
                title: t('modal.info.privateTableNotFound.title'),
                name: EModalName.TABLE_NOT_FOUND,
              },
            )
            await closeModal
            props.onCloseTable()
            return
          } else if (data.data.reason === 'WRONG_PASSWORD') {
            const { closeModal } = openInfoModal(
              {
                text: t('modal.info.wrongTablePassword.text'),
              },
              {
                title: t('modal.info.wrongTablePassword.title'),
                name: EModalName.TABLE_WRONG_PASSWORD,
              },
            )
            await closeModal
            props.onCloseTable()
            return
          }
          break
        }
        break
      }
      case 'poll': {
        if (data.data.authorId === props.userId) {
          break
        }
        await handlePollState(data.data)
        break
      }
      default:
        break
    }
    props.onHandleQueueMessage()
  }

  useEffect(() => {
    if (props.incomingMessage === null) return
    console.log(props.incomingMessage)

    void handleIncomingMessage(props.incomingMessage)
  }, [props.incomingMessage])
}
